import { createAsyncThunk } from '@reduxjs/toolkit'
import { setOwners } from '../owners/ownerSlice'
import axios from 'axios'
import { setLoadFetchedMessages, setMessages } from '../messages/messageSlice'
import { setUsers } from '../users/userSlice'
import { updateThreads } from '../messageThreads/messageThreadSlice'

const typePrefix = 'app/fetchMessages'

export const fetchMessages = createAsyncThunk(
  typePrefix,
  async ({ page, thread_id, per_page }, { dispatch, rejectWithValue, getState }) => {
    try {
      const response = await axios.get('/api/messaging/message_thread', {
        params: { thread_id, page, per_page }
      })

      const state = getState()
      const data = response?.data

      dispatch(updateThreads(data.message_threads))
      dispatch(setLoadFetchedMessages(data.messages))
      dispatch(setOwners(data.owners))
      dispatch(setUsers(data.users))

      return data
    } catch (error) {
      console.log(error)
      return rejectWithValue(error.response.data)
    }
  }
)
